import { ACTION_TYPES } from "../../../server/sbs-api/utils/videoAlertHelper.js";
import { SoccerMatchStatus } from "../../entities/index.js";

export interface IGetMatchStatsQueryString {
  matchId: string;
}

export interface IGetMatchCommentaryQueryString
  extends IGetMatchStatsQueryString {
  lang?: string;
}

export interface IGetMatchQueryString {
  liveScore?: string;
  deltaSince?: string;
}

export interface IGetMatchParams {
  matchId: string;
}

export interface IGetMatchesQueryString {
  tournamentId: string;
  status?: SoccerMatchStatus;
  sort?: "asc" | "desc";
  stageId?: string;
  week?: number;
  since?: string;
  until?: string;
  size?: number;
  liveScore?: string;
  cacheTTL?: string;
}

export interface IGetStandingsQueryString {
  tournamentId: string;
}

export interface ISoccerApiErrorResponse {
  error?: string;
}

interface ProviderId {
  provider: string;
  id: string;
}

interface Resolution {
  height: number;
  width: number;
}

interface VideoUrl {
  fileSize: number;
  url: string;
  bitRate: number;
}

interface CreationSettings {
  ruleId: string;
  ruleName: string;
  creationTimePeriod: string;
  videoType: string;
}

interface CustomData {
  publishPointName: string;
}

interface Team {
  providerTeamId: ProviderId[];
  name: string;
  locale: string;
  score: string;
}

interface Player {
  providerPlayerId: ProviderId[];
  team: Team;
  name: string;
  firstName: string;
  lastName: string;
  nickName: string;
}

interface Game {
  providerGameId: ProviderId[];
  gameDate: string;
  teams: Team[];
  stadium: string;
}

interface ActionParameters {
  shotResult: string;
  bodyPart: string;
  bookingType?: string;
  foulType?: string;
}

interface VideoClipUrl {
  url: string;
  bitRate: number;
}

interface VideoClipThumbnailUrl {
  url: string;
  aspectRatio: string;
}

interface EventClip {
  rating: number;
  id: string;
  title: string;
  clipThumbnailUrl: string;
  clipVideoUrl: string;
  duration: number;
  streamName: string;
  videoClipVideoURLs: VideoClipUrl[];
  videoClipThumbnailURLs: VideoClipThumbnailUrl[];
}

export interface GameEvent {
  actionType: ACTION_TYPES;
  eventType: string;
  providerEventIds: ProviderId[];
  players: Player[];
  gameClock: string;
  time: string;
  game: Game;
  period: string;
  actionParameters: ActionParameters;
  eventClips: EventClip[];
  id: string;
}

export interface GameHighlights {
  id: string;
  title: string;
  competitionId: number;
  contentType: string;
  publishDate: string;
  lastUpdateTime: string;
  publishMethod: string;
  creationSettings: CreationSettings;
  tags: string[];
  duration: number;
  resolution: Resolution;
  videoThumbnailUrl: string;
  videoUrl: string;
  videoUrls: VideoUrl[];
  description: string;
  customData: CustomData;
  events: GameEvent[];
}

export function isSoccerErrorResponse(
  res: unknown
): res is ISoccerApiErrorResponse {
  return !!res && typeof res === "object" && "error" in res;
}
